import { ProductTypeLabel } from 'src/modules/designStudio/helpers/productSelection/types';

type Ranking = { id: string; rank: number };

const ROOF_RANKING: Ranking[] = [
  {
    id: '14',
    rank: 1,
  },
  {
    id: '54',
    rank: 2,
  },
  {
    id: '4',
    rank: 3,
  },
  {
    id: '91',
    rank: 4,
  },
  {
    id: '52',
    rank: 5,
  },
  {
    id: '56',
    rank: 6,
  },
  {
    id: '371',
    rank: 7,
  },
  {
    id: '1201',
    rank: 8,
  },
  {
    id: '325',
    rank: 9,
  },
  {
    id: '299',
    rank: 10,
  },
];

const METAL_ROOF_RANKING: Ranking[] = [
  {
    id: '225',
    rank: 1,
  },
  {
    id: '5839',
    rank: 2,
  },
  {
    id: '424',
    rank: 4,
  },
];

const HORIZONTAL_SIDING_RANKING: Ranking[] = [
  {
    id: '1',
    rank: 1,
  },
  {
    id: '14',
    rank: 2,
  },
  {
    id: '9',
    rank: 3,
  },
  {
    id: '5',
    rank: 4,
  },
  {
    id: '1749',
    rank: 5,
  },
  {
    id: '15',
    rank: 6,
  },
  {
    id: '58',
    rank: 7,
  },
  {
    id: '12',
    rank: 8,
  },
  {
    id: '8532',
    rank: 9,
  },
  {
    id: '5839',
    rank: 10,
  },
  {
    id: '3',
    rank: 11,
  },
  {
    id: '11',
    rank: 12,
  },
  {
    id: '17',
    rank: 13,
  },
  {
    id: '424',
    rank: 14,
  },
  {
    id: '1201',
    rank: 15,
  },
  {
    id: '1745',
    rank: 16,
  },
  {
    id: '57',
    rank: 17,
  },
  {
    id: '296',
    rank: 18,
  },
];

const VERTICAL_SIDING_RANKING: Ranking[] = [
  {
    id: '1',
    rank: 1,
  },
  {
    id: '14',
    rank: 2,
  },
  {
    id: '9',
    rank: 3,
  },
  {
    id: '5',
    rank: 4,
  },
  {
    id: '1749',
    rank: 5,
  },
  {
    id: '15',
    rank: 6,
  },
  {
    id: '58',
    rank: 7,
  },
  {
    id: '12',
    rank: 8,
  },
  {
    id: '8532',
    rank: 9,
  },
  {
    id: '5839',
    rank: 10,
  },
  {
    id: '3',
    rank: 11,
  },
  {
    id: '11',
    rank: 12,
  },
  {
    id: '17',
    rank: 13,
  },
  {
    id: '424',
    rank: 14,
  },
  {
    id: '1201',
    rank: 15,
  },
  {
    id: '1745',
    rank: 16,
  },
  {
    id: '57',
    rank: 17,
  },
  {
    id: '296',
    rank: 18,
  },
];

const SHINGLED_SIDING_RANKING: Ranking[] = [
  {
    id: '1',
    rank: 1,
  },
  {
    id: '14',
    rank: 2,
  },
  {
    id: '9',
    rank: 3,
  },
  {
    id: '5',
    rank: 4,
  },
  {
    id: '1749',
    rank: 5,
  },
  {
    id: '15',
    rank: 6,
  },
  {
    id: '58',
    rank: 7,
  },
  {
    id: '12',
    rank: 8,
  },
  {
    id: '8532',
    rank: 9,
  },
  {
    id: '5839',
    rank: 10,
  },
  {
    id: '3',
    rank: 11,
  },
  {
    id: '1756',
    rank: 12,
  },
  {
    id: '11',
    rank: 13,
  },
  {
    id: '17',
    rank: 14,
  },
  {
    id: '424',
    rank: 15,
  },
  {
    id: '1201',
    rank: 16,
  },
  {
    id: '1745',
    rank: 17,
  },
  {
    id: '57',
    rank: 18,
  },
];

const BRICK_SIDING_RANKING: Ranking[] = [
  { id: '7', rank: 1 },
  { id: '6', rank: 2 },
];

const STONE_SIDING_RANKING: Ranking[] = [
  { id: '5839', rank: 1 },
  { id: '58', rank: 2 },
  { id: '1756', rank: 3 },
  { id: '14', rank: 4 },
  { id: '8502', rank: 5 },
  { id: '3', rank: 6 },
];

const TRIM_RANKING: Ranking[] = [
  { id: '1', rank: 1 },
  { id: '14', rank: 2 },
  { id: '9', rank: 3 },
  { id: '5', rank: 4 },
  { id: '1749', rank: 5 },
  { id: '15', rank: 6 },
  { id: '12', rank: 7 },
  { id: '8532', rank: 8 },
  { id: '5839', rank: 9 },
  { id: '11', rank: 10 },
  { id: '17', rank: 11 },
  { id: '1745', rank: 12 },
];

export const RANKINGS_BY_LABELS: Record<ProductTypeLabel, Ranking[]> = {
  [ProductTypeLabel.HORIZONTAL_SIDING]: HORIZONTAL_SIDING_RANKING,
  [ProductTypeLabel.VERTICAL_SIDING]: VERTICAL_SIDING_RANKING,
  [ProductTypeLabel.SHINGLED_SIDING]: SHINGLED_SIDING_RANKING,
  [ProductTypeLabel.BRICK_SIDING]: BRICK_SIDING_RANKING,
  [ProductTypeLabel.STONE_SIDING]: STONE_SIDING_RANKING,
  [ProductTypeLabel.CONCRETE_SIDING]: [],
  [ProductTypeLabel.STUCCO_SIDING]: [],

  [ProductTypeLabel.SHINGLE_ROOF]: ROOF_RANKING,
  [ProductTypeLabel.TILE_ROOF]: ROOF_RANKING,
  [ProductTypeLabel.METAL_ROOF]: METAL_ROOF_RANKING,

  [ProductTypeLabel.TRIM]: TRIM_RANKING,
};
